module.exports = __webpack_public_path__ + "static/outline-dc5b8a3ab2162812ac5e9157b97fd8b5.png";